/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EventDetailDto } from '../models/EventDetailDto';
import type { PaginatedEventListDto } from '../models/PaginatedEventListDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EventsService {
  /**
   * 이벤트 목록 조회
   * @returns PaginatedEventListDto
   * @throws ApiError
   */
  public static eventControllerFindAllEventsWithPagination({
    page = 1,
    itemsPerPage = 30,
  }: {
    page?: number;
    itemsPerPage?: number;
  }): CancelablePromise<PaginatedEventListDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/events',
      query: {
        page: page,
        itemsPerPage: itemsPerPage,
      },
    });
  }

  /**
   * 이벤트 상세 조회
   * @returns EventDetailDto
   * @throws ApiError
   */
  public static eventControllerFindOneById({
    eventId,
  }: {
    eventId: number;
  }): CancelablePromise<EventDetailDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/events/{eventId}',
      path: {
        eventId: eventId,
      },
    });
  }
}
